export default "__VITE_ASSET__5ab8ce07__"